/*
 * File: IssueForm.ts
 * Author: Austin Robinson
 * Date Created: 6/2/2023
 * Copyright (c) DrivingDoc 2023
 */

import { AxiosError } from "axios";
import { createMutation } from "react-query-kit";
import { privateApi } from 'api';

export interface IssueIndianaCDEFormParams {
    courseEnrollmentId: string,
}

async function issueIndianaCDEForm(params: IssueIndianaCDEFormParams): Promise<boolean> {
    if (params === undefined) {
        return false;
    }

    // make api call
    const result = await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/forms/indiana/certificationOfDriverEducationEnrollment`, params, {

    });

    return !!result.data;

}

const useIssueIndianaCDEForm = createMutation<boolean, IssueIndianaCDEFormParams, AxiosError<unknown>>({
    mutationFn: async (variables: IssueIndianaCDEFormParams) => issueIndianaCDEForm(variables),
});

export { useIssueIndianaCDEForm };
